var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwiperArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.8598,
    height: 27,
    rx: 13.4299,
    fill: "#f5f5fc",
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6265 7.73237C16.553 7.65871 16.4657 7.60027 16.3696 7.5604C16.2735 7.52052 16.1705 7.5 16.0665 7.5C15.9625 7.5 15.8594 7.52052 15.7633 7.5604C15.6673 7.60027 15.58 7.65871 15.5065 7.73237L10.185 13.0538C10.1264 13.1124 10.0798 13.1819 10.0481 13.2584C10.0163 13.335 10 13.417 10 13.4999C10 13.5828 10.0163 13.6648 10.0481 13.7414C10.0798 13.8179 10.1264 13.8875 10.185 13.946L15.5065 19.2675C15.8165 19.5775 16.3164 19.5775 16.6265 19.2675C16.9365 18.9574 16.9365 18.4575 16.6265 18.1475L11.9821 13.5031L16.6328 8.85234C16.9365 8.54229 16.9365 8.04242 16.6265 7.73237Z",
    fill: "#747787"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperArrow);
export default __webpack_public_path__ + "static/media/swiper-arrow.7b09668745b72d5ddd37dc7d676fca16.svg";
export { ForwardRef as ReactComponent };